var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import cn from "classnames";
import { bem } from "@react-md/utils";
var block = bem("rmd-media-container");
/**
 * The `MediaContainer` component is used to make responsive images and videos
 * within your app. This component also allows for forcing a specific aspect
 * ratio for these elements with both the `height` and `width` props are
 * provided.
 */
export var MediaContainer = forwardRef(function MediaContainer(_a, ref) {
    var className = _a.className, height = _a.height, width = _a.width, children = _a.children, _b = _a.auto, auto = _b === void 0 ? true : _b, _c = _a.fullWidth, fullWidth = _c === void 0 ? false : _c, props = __rest(_a, ["className", "height", "width", "children", "auto", "fullWidth"]);
    var aspectRatio = height && width ? "rmd-media-container--".concat(width, "-").concat(height) : "";
    return (_jsx("div", __assign({}, props, { ref: ref, className: cn(block({
            auto: auto,
            "aspect-ratio": aspectRatio,
            "full-width": fullWidth,
        }), aspectRatio, className) }, { children: children })));
});
//# sourceMappingURL=MediaContainer.js.map